import { connect } from 'react-redux'
import OrdersEditView from './OrdersEditView.jsx'


class OrdersApproveView extends OrdersEditView {
  constructor(props, context) {
    const localProps = {
      ...props,
      initialState: {
        status: 'approved'
      }
    }

    super(localProps, context)
  }
}

const mapStateToProps = (state) => {
  return {
    page: 'approve',
    order: state.orders.current.order,
    currentUser: state.currentUser.user,
    skus: state.skus.all || [],
    serverErrors: state.errors.orders.create || {}
  }
}

const connectedOrdersApproveView = connect(mapStateToProps)(OrdersApproveView)
export default connectedOrdersApproveView